module.exports = __webpack_public_path__ + "img/do_request_button.b843137b.png";